module.exports = __webpack_public_path__ + "img/gift.cf746c6e.svg";